import type { QueryKeyTuple, QueryKeyValue } from './helpers'

export const createKeyFactory = <TNamespace extends string>(namespace: TNamespace) => {
  const all = () => [namespace] as const

  const list = <TParams extends Record<string, unknown>>(params?: TParams) => {
    if (params) {
      return [namespace, 'list', params] as const
    }

    return [namespace, 'list'] as const
  }

  const detail = <TId extends string | number>(id: TId) => {
    return [namespace, 'detail', { id }] as const
  }

  const custom = <TParts extends QueryKeyValue[]>(...parts: TParts) => {
    return [namespace, ...parts] as QueryKeyTuple
  }

  return {
    all,
    list,
    detail,
    custom,
  }
}
